import { createContext } from 'react';
import { IPromoOffer } from '../../types/promoDetails';

export const PromoOfferCardContext = createContext<IPromoOffer>({} as IPromoOffer);
